<template>
  <div class="art2">
    <div>
      <img src="~@/assets/images/art-page2-img-1.jpg" />
    </div>
    <div>&nbsp;</div>
    <div>&nbsp;</div>
    <div>
      台灣雕刻藝術大師陳正雄先生，於民國三十一年，誕生於台灣。十四歲時透過介紹到北港的佛像雕刻店當學徒。十七歲時出師，之後跟隨一位唐山老師父，外出到各地廟宇就地工作，六年的時光，從台灣頭做到台灣尾，也為傳統的雕刻功夫打下深厚紮實的基礎。
    </div>
    <div>&nbsp;</div>
    <div>
      直到有一次，因為母親身體不適，請了許嘉煢醫師到家裡診治，看到了陳正雄先生的兩件雕刻作品，許醫師建議他送去參加「南美展」，兩件作品竟參加就獲獎，令他信心大增，自此更加勤奮地從事創作性與表現性的嘗試。
    </div>
    <div>&nbsp;</div>
    <div>
      陳正雄先生先後參加了南美展、省美展、日本新構造展等，不但連年得到南美展最高獎項的榮譽，至1989不但破天荒得到日本東京美術館新構造的「彫刻大賞」，更獲邀於歷史博物館的國家畫廊舉行了個展...雖然沒有受過學院薰陶或名家指導，陳正雄靠著天份和努力，從小學畢業一路進入公認的美學殿堂，他的藝術特長兼具傳統與創新，從神靈世界的創新思考，大膽切入了現實社會的觀察與生命情態的記錄與捕捉。
    </div>
    <div>&nbsp;</div>
    <div>
      陳正雄的人像雕刻，在形象寫實的結構上，深藏自由灑脫的力度，立體呈現了材料的洞識，生活的觀察，社會的訊息，和命運的見解，隨著刀鋒入木的雕創過程，展現材料原質的美感肌理，伴隨著台灣人的容顏特徵，個體的存有狀態，特定族群的心理徵貌，和一種深情的詮釋方式，構成了陳正雄雕刻大師的個人風格特色，也豐富了台灣雕塑藝術的內容。
    </div>
  </div>
</template>

<script>
export default {
  name: 'Art2',
  data() {
    return {
      page: this.$route.query.page,
    };
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
  },
};
</script>

<style scoped>
.art2 img {
  max-width: 100%;
}
</style>
